export default {"src":"/_next/static/media/dryer.549537cc.svg","height":100,"width":100};